// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_tooltip__2PkMs {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 420px;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", sans-serif;
}
@media (max-width: 768px) {
  .styles_tooltip__2PkMs {
    max-width: 85vw;
    font-size: 14px;
  }
}

.styles_tooltipHeader__J-pbm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
}

.styles_tooltipTitle__HTlFy {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}
@media (max-width: 768px) {
  .styles_tooltipTitle__HTlFy {
    font-size: 16px;
  }
}

.styles_closeButton__NsZa7 {
  background: none;
  border: none;
  font-size: 20px;
  color: #6b7280;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
  transition: color 0.2s;
}
.styles_closeButton__NsZa7:hover {
  color: #1f2937;
}
.styles_closeButton__NsZa7:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
  border-radius: 4px;
}
@media (max-width: 768px) {
  .styles_closeButton__NsZa7 {
    padding: 8px;
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.styles_tooltipContent__s\\+iBI {
  padding: 12px 16px;
}
.styles_tooltipContent__s\\+iBI p {
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: #4b5563;
}
@media (max-width: 768px) {
  .styles_tooltipContent__s\\+iBI p {
    font-size: 14px;
  }
}

.styles_tooltipFooter__YYaF2 {
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 768px) {
  .styles_tooltipFooter__YYaF2 {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
}

.styles_progressIndicator__F0HlY {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}
@media (max-width: 768px) {
  .styles_progressIndicator__F0HlY {
    text-align: center;
    order: 2;
  }
}

.styles_buttonGroup__VmYv3 {
  display: flex;
  gap: 8px;
}
@media (max-width: 768px) {
  .styles_buttonGroup__VmYv3 {
    width: 100%;
    order: 1;
  }
}

.styles_skipButton__cdWVO,
.styles_backButton__c-wyP,
.styles_nextButton__R6c7E {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}
.styles_skipButton__cdWVO:focus,
.styles_backButton__c-wyP:focus,
.styles_nextButton__R6c7E:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
@media (max-width: 768px) {
  .styles_skipButton__cdWVO,
  .styles_backButton__c-wyP,
  .styles_nextButton__R6c7E {
    flex: 1 1;
    padding: 10px 12px;
    min-height: 44px;
  }
}

.styles_skipButton__cdWVO {
  background: white;
  color: #6b7280;
  border-color: #d1d5db;
}
.styles_skipButton__cdWVO:hover {
  background: #f9fafb;
  color: #4b5563;
}

.styles_backButton__c-wyP {
  background: white;
  color: #3b82f6;
  border-color: #3b82f6;
}
.styles_backButton__c-wyP:hover {
  background: #eff6ff;
}

.styles_nextButton__R6c7E {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}
.styles_nextButton__R6c7E:hover {
  background: #2563eb;
}

.react-joyride__overlay {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
.react-joyride__spotlight {
  border-radius: 8px !important;
}

.styles_transitionOverlay__pWnRZ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
}

.styles_transitionMessage__MrwFc {
  background: white;
  padding: 24px 32px;
  border-radius: 12px;
  text-align: center;
}
.styles_transitionMessage__MrwFc p {
  margin: 12px 0 0;
  font-size: 16px;
  color: #1f2937;
}

.styles_spinner__hhpWp {
  width: 40px;
  height: 40px;
  border: 4px solid #e5e7eb;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: styles_spin__R2xYn 0.8s linear infinite;
  margin: 0 auto;
}

@keyframes styles_spin__R2xYn {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/onboarding-tour/styles.module.scss"],"names":[],"mappings":"AAGA;EACE,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,UAAA;EACA,0FAAA;AAFF;AAIE;EARF;IASI,eAAA;IACA,eAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AADF;;AAIA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADF;AAGE;EANF;IAOI,eAAA;EAAF;AACF;;AAGA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AAAF;AAEE;EACE,cAAA;AAAJ;AAGE;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AADJ;AAIE;EApBF;IAqBI,YAAA;IACA,eAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EADF;AACF;;AAIA;EACE,kBAAA;AADF;AAGE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAGI;EANF;IAOI,eAAA;EAAJ;AACF;;AAIA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADF;AAGE;EAPF;IAQI,sBAAA;IACA,SAAA;IACA,oBAAA;EAAF;AACF;;AAGA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAAF;AAEE;EALF;IAMI,kBAAA;IACA,QAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;AACE;EAJF;IAKI,WAAA;IACA,QAAA;EAEF;AACF;;AACA;;;EAGE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,6BAAA;AAEF;AAAE;;;EACE,0BAAA;EACA,mBAAA;AAIJ;AADE;EAhBF;;;IAiBI,SAAA;IACA,kBAAA;IACA,gBAAA;EAMF;AACF;;AAHA;EACE,iBAAA;EACA,cAAA;EACA,qBAAA;AAMF;AAJE;EACE,mBAAA;EACA,cAAA;AAMJ;;AAFA;EACE,iBAAA;EACA,cAAA;EACA,qBAAA;AAKF;AAHE;EACE,mBAAA;AAKJ;;AADA;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AAIF;AAFE;EACE,mBAAA;AAIJ;;AAEE;EACE,+CAAA;AACJ;AAEE;EACE,6BAAA;AAAJ;;AAKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAFF;AAIE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAFJ;;AAMA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kDAAA;EACA,cAAA;AAHF;;AAMA;EACE;IAAK,yBAAA;EAFL;AACF","sourcesContent":["@import \"mixins\";\n// Tour Tooltip Styles\n\n.tooltip {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  max-width: 420px;\n  padding: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', sans-serif;\n\n  @media (max-width: 768px) {\n    max-width: 85vw;\n    font-size: 14px;\n  }\n}\n\n.tooltipHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.tooltipTitle {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n\n  @media (max-width: 768px) {\n    font-size: 16px;\n  }\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 4px;\n  line-height: 1;\n  transition: color 0.2s;\n\n  &:hover {\n    color: #1f2937;\n  }\n\n  &:focus {\n    outline: 2px solid #3b82f6;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n\n  @media (max-width: 768px) {\n    padding: 8px;\n    min-width: 44px;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.tooltipContent {\n  padding: 12px 16px;\n\n  p {\n    margin: 0;\n    font-size: 15px;\n    line-height: 1.6;\n    color: #4b5563;\n\n    @media (max-width: 768px) {\n      font-size: 14px;\n    }\n  }\n}\n\n.tooltipFooter {\n  padding: 12px 16px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n  }\n}\n\n.progressIndicator {\n  font-size: 13px;\n  color: #6b7280;\n  font-weight: 500;\n\n  @media (max-width: 768px) {\n    text-align: center;\n    order: 2;\n  }\n}\n\n.buttonGroup {\n  display: flex;\n  gap: 8px;\n\n  @media (max-width: 768px) {\n    width: 100%;\n    order: 1;\n  }\n}\n\n.skipButton,\n.backButton,\n.nextButton {\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 1px solid transparent;\n\n  &:focus {\n    outline: 2px solid #3b82f6;\n    outline-offset: 2px;\n  }\n\n  @media (max-width: 768px) {\n    flex: 1;\n    padding: 10px 12px;\n    min-height: 44px;\n  }\n}\n\n.skipButton {\n  background: white;\n  color: #6b7280;\n  border-color: #d1d5db;\n\n  &:hover {\n    background: #f9fafb;\n    color: #4b5563;\n  }\n}\n\n.backButton {\n  background: white;\n  color: #3b82f6;\n  border-color: #3b82f6;\n\n  &:hover {\n    background: #eff6ff;\n  }\n}\n\n.nextButton {\n  background: #3b82f6;\n  color: white;\n  border-color: #3b82f6;\n\n  &:hover {\n    background: #2563eb;\n  }\n}\n\n// Overlay customization (global styles for React Joyride)\n:global {\n  .react-joyride__overlay {\n    background-color: rgba(0, 0, 0, 0.5) !important;\n  }\n\n  .react-joyride__spotlight {\n    border-radius: 8px !important;\n  }\n}\n\n// Transition loading overlay\n.transitionOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  z-index: 10001; // Above Joyride\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.transitionMessage {\n  background: white;\n  padding: 24px 32px;\n  border-radius: 12px;\n  text-align: center;\n\n  p {\n    margin: 12px 0 0;\n    font-size: 16px;\n    color: #1f2937;\n  }\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e5e7eb;\n  border-top-color: #3b82f6;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin: 0 auto;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `styles_tooltip__2PkMs`,
	"tooltipHeader": `styles_tooltipHeader__J-pbm`,
	"tooltipTitle": `styles_tooltipTitle__HTlFy`,
	"closeButton": `styles_closeButton__NsZa7`,
	"tooltipContent": `styles_tooltipContent__s+iBI`,
	"tooltipFooter": `styles_tooltipFooter__YYaF2`,
	"progressIndicator": `styles_progressIndicator__F0HlY`,
	"buttonGroup": `styles_buttonGroup__VmYv3`,
	"skipButton": `styles_skipButton__cdWVO`,
	"backButton": `styles_backButton__c-wyP`,
	"nextButton": `styles_nextButton__R6c7E`,
	"transitionOverlay": `styles_transitionOverlay__pWnRZ`,
	"transitionMessage": `styles_transitionMessage__MrwFc`,
	"spinner": `styles_spinner__hhpWp`,
	"spin": `styles_spin__R2xYn`
};
export default ___CSS_LOADER_EXPORT___;
